import { JSX } from "react";

import { Person } from "@mui/icons-material";
import { Theme } from "@mui/material";

export interface IProfileButtonParams {
  username?: string;
  familyName?: string;
  handleClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
  isOpen: boolean;
}

export function getAvatarName(name?: string): string | JSX.Element {
  return name?.length ? name[0].toUpperCase() : <Person />;
}

const AVATAR_SIZE = 36;
const AVATAR_FONTWEIGHT = 500;

export const avatarStyles = (theme: Theme) => ({
  backgroundColor: theme.palette.primary.main,
  height: AVATAR_SIZE,
  width: AVATAR_SIZE,
  fontSize: AVATAR_SIZE / 2,
  fontWeight: AVATAR_FONTWEIGHT,
});
